<div class="flex">
  <sbnb-subnav class="w-[280px] hidden min-[960px]:block" [header]="'GUESTXP.GUESTXP' | transloco">
    <sbnb-gx-subnav></sbnb-gx-subnav>
  </sbnb-subnav>

  <main class="flex-1 flex flex-col gap-8 subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <ng-container *ngTemplateOutlet="headerSection"></ng-container>

    <mat-tab-group [@.disabled]="true">
      <mat-tab label="Templates">
        <ng-template matTabContent>
          <sbnb-reservation-agreement-templates></sbnb-reservation-agreement-templates>
        </ng-template>
      </mat-tab>

      <mat-tab [label]="(isMobile$ | async) ? 'Pending' : 'Pending Agreements'">
        <ng-template matTabContent>
          <sbnb-signed-reservation-agreements [signed]="false"></sbnb-signed-reservation-agreements>
        </ng-template>
      </mat-tab>

      <mat-tab [label]="(isMobile$ | async) ? 'Signed' : 'Signed Agreements'">
        <ng-template matTabContent>
          <sbnb-signed-reservation-agreements [signed]="true"></sbnb-signed-reservation-agreements>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </main>
</div>

<ng-template #headerSection>
  <section id="header" class="flex flex-col gap-0">
    <app-feature-flag-tabs>
      <sbnb-page-header class="!mb-0" navTabs>
        <div class="flex w-full justify-between">
          <h2 class="nomargin flex-1 text-center sbnbDesktop:text-left mb-0">Rental Agreements</h2>
          <sbnb-button
            class="absolute right-0 sbnbDesktop:relative"
            size="mini"
            (clicked)="createNewReservationAgreement()">
            +
            <span class="hidden sbnbDesktop:inline-block">&nbsp;Add new</span>
          </sbnb-button>
        </div>
      </sbnb-page-header>

      <div class="flex w-full justify-between">
        <h2 class="nomargin flex-1">Rental Agreements</h2>
        <sbnb-button size="mini" (clicked)="createNewReservationAgreement()">+ Add new</sbnb-button>
      </div>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'gx-rental-agreements'"></sbnb-helptext-wrapper>
  </section>
</ng-template>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
